import '../styles/style.scss';
import {v4 as uuidv4} from "uuid";
import { Outlet, useLocation } from 'react-router-dom';
import { useStoreCtx } from '../store';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { useEffect, useState } from 'react';
import {getClientID, tvhEnvironmentApi} from '../util/helpers';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { SHELVES_ITEM_LINK } from '../util/interfaces';
import { Subscription } from '../util/promo';

SwiperCore.use([Autoplay])

export const IndexView = observer(() => {
	const httpService = useStoreCtx().appStore
	const sessionId = uuidv4()
	const location = useLocation()

	useEffect(() => {
		console.log('location', location.pathname);
		httpService.clearSessionSaveOldValues(
			window.sessionStorage.getItem("request_id"),
			window.sessionStorage.getItem("analyticsQuery"),
			window.sessionStorage.getItem("subscription_period"),
		)
		if (location.pathname === '/') {
			const intervalId = setInterval(() => {
				if (getClientID()) {
					clearInterval(intervalId)
					httpService.pushEvent({event_name: 'screen_show'})
				}
			}, 500)
		} else if (location.pathname === '/ssoauth') {
			const intervalId = setInterval(() => {
				if (httpService.grclientid) {
					clearInterval(intervalId)
					httpService.pushEvent({event_name: 'screen_show'})
				}
			}, 500)
		}
	}, [])

	function webSsoAuth(subscription?: Subscription) {
		if (!subscription) {
			window.sessionStorage.removeItem("subscription_period")
		} else {
			httpService.selectedSubscription = subscription;
			window.sessionStorage.setItem("subscription_period", subscription.promotion.timeToLiveValue.toString())
		}

		window.sessionStorage.setItem("request_id", uuidv4())
		httpService.pushEvent({
		  event: 'authorization_start',
		  event_name: 'authorization_start',
		  referer: '',
		  auth_method: "sms",
		  auth_type: 'websso',
		  request_id: window.sessionStorage.getItem("request_id")
		})

		const hostUrl = window.location.host
		window.location.assign(
		  encodeURI(
			  `https://${tvhEnvironmentApi}/tvh-public-api-gateway/public/rest/general/websso/redirect?state=${sessionId}&clientType=WEB&domain=${hostUrl}`
		  )
		);
	}

	const [data, setData] = useState<{img: string; link: string;}[]>([]);
	const postersFirst = data.filter((_, idx) => idx <= data.length/2) || [];
	const postersSecond = data.filter((_, idx) => idx > data.length/2) || [];

	async function getData() {
		await httpService.getImgsForSwapper().then((response) => {
			const posters = response.data.items.filter(item => item.imageUrl.startsWith('http')).map(item => {
				let link = '';
				if (item.link.linkType === SHELVES_ITEM_LINK.MOVIE) {
					link = "https://kion.ru/video/movie/" + item.link.movieContentId;
				} else {
					link = "https://kion.ru/video/serial/" + item.link.seriesContentId;
				}

				return {img: item.imageUrl, link: link}
			})
			setData(posters)
		})
	}

	useEffect(() => {
		getData()
	}, [])

	const newItems = [
		{ img: 'images/new-items/newItem4.png' },
		{ img: 'images/new-items/newItem2.png' },
		{ img: 'images/new-items/newItem3.png' },
		{ img: 'images/new-items/newItem1.png' },
		{ img: 'images/new-items/newItem5.png' },
		{ img: 'images/new-items/newItem6.png' },
	];

	const newItemsCgn = [
		{ img: 'images/new-items/newItemCgn1.png' },
		{ img: 'images/new-items/newItemCgn2.png' },
		{ img: 'images/new-items/newItemCgn3.png' },
		{ img: 'images/new-items/newItemCgn4.png' },
		{ img: 'images/new-items/newItemCgn5.png' },
		{ img: 'images/new-items/newItemCgn6.png' },
	];

	const addFeatures = [
		{
			img: 'images/add-features/af1.png',
			header: 'Кион Строки',
			feature: 'Книги и аудиокниги',
			discountPrice: '0 ₽',
			fullPrice: 'от 299 ₽'
		},
		{
			img: 'images/add-features/af2.png',
			header: 'Кион Музыка',
			feature: 'Музыка без ограничений*',
			footnote: 'Услуга доступна через активацию промокода',
			discountPrice: '0 ₽',
			fullPrice: '169 ₽'
		},
		{
			img: 'images/add-features/af6.png',
			header: 'Самокаты Юрент',
			feature: 'Бесплатный старт',
			discountPrice: '0 ₽',
			fullPrice: '149 ₽'
		},
		{
			img: 'images/add-features/af9.png',
			header: 'Для абонентов МТС',
			feature: 'Защита от спам-звонков',
			discountPrice: '',
			fullPrice: ''
		},
		{
			img: 'images/add-features/af8.png',
			header: 'Belka Car',
			feature: 'Кешбэк 10% на каршеринг',
			discountPrice: '',
			fullPrice: ''
		}
	];

	const [isAnalyticsQuery, setIsAnalyticsQuery] = useState<boolean>(false);
	const [isCgnType, setIsCgnType] = useState<boolean>(false);
	const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);

	useEffect(() => {
		const queryParams = location.search;

		if (queryParams.includes('utm_source')) {
			setIsAnalyticsQuery(true);
			setSubscriptions(httpService.subscriptions);
		} else {
			setIsAnalyticsQuery(false);
			setSubscriptions(httpService.subscriptionsWithoutQuery);
		}

		if (queryParams.includes('cgn_type=brand_popular_content')) setIsCgnType(true);
	}, []);	

	return (
		<>
        	<Outlet/>

			<header className="header">
				<div className="wrapper">
					<a className="logo" href="https://kion.ru/"><svg width="138" height="44" viewBox="0 0 280 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 58.3223V0H18.7464V22.9956L33.577 0H54.1564L34.91 28.4946L54.1564 58.3223H32.2439L18.7464 36.0765V58.3223H0ZM56.9059 58.3223V0H75.6523V32.7438L93.7322 0H114.395V58.3223H95.6485V25.5785L77.5686 58.3223H56.9059ZM221.875 58.3223V0H240.621V20.4128H261.034V0H279.78V58.3223H261.034V37.9095H240.621V58.3223H221.875ZM140.64 39.9924H195.63V18.3299H140.64V39.9924ZM121.06 58.3223V0H215.209V58.3223H121.06Z" fill="white"/></svg></a>
				</div>
			</header>

			<div className="f_screen">
				<div className="text">
					<h1>
						Максимум привилегий 
						с&nbsp;КИОН+Premium
					</h1>
					<div className="desc">
						Онлайн-кинотеатр КИОН и все преимущества подписки Premium*.
						Для подключения не обязательно быть абонентом МТС
					</div>
					<button 
						onClick={() => webSsoAuth()} 
						className={clsx('btn', httpService.subscriptionExist && 'disabled-button')}
					>
						{httpService.subscriptionExist ? 'Вы уже подписаны' : 'Подключить'}
					</button>
				</div>
				{isCgnType ? (
					window.innerWidth > 766 ? (
						<img src="images/images-block/main-image-cgn.png"/>
					) : (
						<img src="images/images-block/main-image-cgn-mobile.png"/>
					)
				) : (
					window.innerWidth > 766 ? (
						<img src="images/images-block/main-image.png"/>
					) : (
						<img src="images/images-block/main-image-mobile.png"/>
					)
				)}
			</div>

			<div className="main-content">
				<div className="swiper-block">
					<div className="sb-header">
						<h2>Подключи подписку и начни смотреть&nbsp;уже&nbsp;сейчас</h2>
					</div>
					<div className="images">
						<div className="images-content">
							{postersFirst.length && (
								<Swiper 
									className="sample-slider" 
									modules={[Autoplay]}
									slidesPerView={'auto'} 
									autoplay={{ delay: 0 }} 
									speed={8000} 
									loop={true}
								>
									{postersFirst.map((poster, idx) => (
										<SwiperSlide key={idx} className="img-block">
											<a href={poster.link}>
												<img src={poster.img} />
											</a>
										</SwiperSlide>
									))}
								</Swiper>
							)}

							{postersSecond.length && (
								<Swiper 
									className="sample-slider" 
									modules={[Autoplay]}
									slidesPerView={'auto'}
									autoplay={{ delay: 0, reverseDirection: true }} 
									initialSlide={1} 
									speed={8000} 
									loop={true}
								>
									{postersSecond.map((poster, idx) => (
										<SwiperSlide key={idx} className="img-block">
											<a href={poster.link}>
												<img src={poster.img} />
											</a>
										</SwiperSlide>
									))}
								</Swiper>
							)}
						</div>
					</div>
				</div>

				<div className="economy_block">
					<div className="tariffs">
						<h2>Экономь с Кион+Premium**</h2>
						<div className="tariff_block">
							{subscriptions.map((sub) => (
									<div className="tariff">
										<div className="period">{sub.promotion.period}</div>
										<div className="price_block">
											<div className="discount_price">{sub.discountPrice / 100} ₽</div>
											{sub.price !== sub.discountPrice && <div className="full_price">{sub.price / 100}₽</div>}
										</div>
										<button 
											onClick={() => webSsoAuth(sub)} 
											className={clsx('btn', httpService.subscriptionExist && 'disabled-button')}
										>
											{httpService.subscriptionExist ? 'Вы уже подписаны' : 'Подключить'}
										</button>
									</div>
								))}
							</div>
					</div>

					<div className="new_items_block">
						<h3>Новинки каждую неделю</h3>
						{isCgnType ? (
							<div className="new_items">
								{newItemsCgn.map((item) => (
									<div className='image_container'><img src={item.img} /></div>
								))}
							</div>
						) : (
							<div className="new_items">
								{newItems.map((item) => (
									<div className='image_container'><img src={item.img} /></div>
								))}
							</div>
						)}
					</div>

					<div className="tiles">
						<div className="big_tile">
							<h3>Фильмы и сериалы, доступные только на Кион</h3>
							{isCgnType ? <img className="img1-cgn" src="images/kion-films-cgn.png"/> : <img className="img1" src="images/kion-films.png"/>}
						</div>
						<div className="right_tiles">
							<div className="small_tile">
								<h3>200+ ТВ каналов</h3>
								<img className="img2" src="images/200-tv.png"/>
							</div>
							<div className="small_tile">
								<h3>Умная система рекомендаций</h3>
								<img className="img3" src="images/smart-system-recomm.png"/>
							</div>
						</div>
					</div>
				</div>

				<div className="add_features_block">
					<h2>Дополнительные возможности&nbsp;КИОН+Premium</h2>

					<div className="features">
						{addFeatures.map((item) => (
							<div className="item_feature">
								<div className="left_block">
									<img src={item.img}/>
									<div className="info">
										<div className="name" dangerouslySetInnerHTML={{ __html: item.header }}/>
										<div className="desc" dangerouslySetInnerHTML={{ __html: item.feature }}/>
										{item.footnote && (
											<div className="footnote" dangerouslySetInnerHTML={{ __html: item.footnote }}/>
										)}
									</div>
								</div>
								<div className="price">
									<div className="discount_price">{item.discountPrice}</div>
									<div className="full_price">{item.fullPrice}</div>
								</div>
							</div>
						))}
					</div>
				</div>

				<div className={clsx("footer", isCgnType && "footer-cgn")}>
					<div className="text">
						<p>
							© 2026 ООО «КИОН». Все права защищены. 12+
						</p>
						{isAnalyticsQuery ?
							<p>
								* Специальные цены действительны при подключении новых клиентов (не имеющих на момент подключения действующей подписки КИОН) по акции на сайте <a href="https://premium.kion.ru">premium.kion.ru</a> с 01.05.2026 г. по 30.06.2026 г. (включительно). Подписка КИОН+Premium включает подписку «МТС Premium» 
								<a href="https://premium.mts.ru">(https://premium.mts.ru/)</a>. Организатор акции вправе менять условия и период проведения акции. Пользовательское соглашение: <a href="https://kion.ru/user-agreement">https://kion.ru/user-agreement</a>
							</p>
						:
							<p>
								* Специальные цены действительны при подключении новых клиентов (не имеющих на момент подключения действующей подписки КИОН) по акции
								на сайте <a href="https://premium.kion.ru">premium.kion.ru</a> с 01.05.2026 г. по 30.06.2026 г. (включительно) Подписка КИОН+Premium включает подписку «МТС Premium»
								<a href="https://premium.mts.ru">(https://premium.mts.ru/)</a>. Организатор акции вправе менять условия и период проведения акции. Пользовательское соглашение: <a href="https://kion.ru/user-agreement">https://kion.ru/user-agreement</a>
							</p>
						}
						{isAnalyticsQuery ?
							<p>
								** Для всех пользователей: «КИОН+Premium» на 1 месяц – 99 р., далее автопродление - 349 р. в месяц, «КИОН+Premium» на 3 месяца – 299 р., далее автопродление - 750 р. раз в 3 месяца, «КИОН+Premium» на 1 год – 999 р., далее автопродление - 2450 р. в год.
							</p>
							:
							<p>
								** Для всех пользователей: «КИОН+Premium» на 1 год – 999 р., далее автопродление - 2490 р. в год.
							</p>
						}
					</div>
				</div>				
			</div>
		</>
	);
})